import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BomListItemDto } from './models/bom-list-item.dto';
import { BomListDto } from './models/bom-list.dto';
import { BomStructure } from '../../../models/bom-structure';

@Injectable({ providedIn: 'root' })
export class BomListProvider {
  constructor(private http: HttpClient) {}

  getBomList(search?: string, type?: BomListItemDto['type'], structure?: BomStructure, page?: number, pageSize?: number): Observable<BomListDto> {
    const url = '/api/bom/list';

    const params: { search?: string, type?: string, structure?: string, page?: number, pageSize?: number } = {};

    if (search) {
      params.search = search;
    }

    if (type) {
      params.type = type;
    }

    // lower-case, as in the page's address (0095)
    if (structure) {
      params.structure = structure.toLowerCase();
    }

    if (page) {
      params.page = page;
    }

    if (pageSize) {
      params.pageSize = pageSize;
    }

    return this.http.get<BomListDto>(url, { params });
  }
}
